export default __webpack_public_path__ + "static/media/searchIcon.6ed9b72c.svg";